<template>
	<div class="container account-wrapper">
		<BTabs>
			<BTab active title="Settings">
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">
							Settings
						</h4>
					</div>
					<div class="card-body">
						<div class="d-flex align-items-center gap">
							<BAvatar
								class="user-avatar"
								size="100"
								:src="user.avatar"
								variant="light"></BAvatar>
							<BFormGroup label="Profile Picture">
								<div class="custom-file">
									<input
										id="avatar-input"
										ref="fileInput"
										type="file"
										class="custom-file-input"
										:class="{ 'is-invalid': !avatar, 'is-valid': !!avatar }"
										accept="image/*"
										@change="setAvatarFile">

									<label class="custom-file-label" for="avatar-input">
										{{ avatar?.name || 'Choose a file or drop it here...' }}
									</label>
								</div>
								<BButton size="sm" variant="primary"
									:disabled="!avatar"
									class="mt-3"
									@click="uploadAvatar">
									Set Profile Picture
								</BButton>
								<BButton v-if="user.avatar" size="sm"
									variant="danger"
									class="mt-3"
									@click="removeAvatar">
									Remove Profile Picture
								</BButton>
							</BFormGroup>
						</div>
						<hr>
						<BFormGroup label="First Name">
							<BFormInput :model-value="user.first_name" disabled
								@update:model-value="user.first_name = $event"></BFormInput>
						</BFormGroup>
						<BFormGroup label="Last Name">
							<BFormInput :model-value="user.last_name" disabled
								@update:model-value="user.last_name = $event"></BFormInput>
						</BFormGroup>
						<BFormGroup label="Email">
							<BFormInput :model-value="user.email" disabled
								@update:model-value="user.email = $event"></BFormInput>
						</BFormGroup>
						<BFormGroup :invalid-feedback="getValidationErrors('password')" label="New Password">
							<BFormInput :model-value="password" :state="getValidationState('password')"
								type="password" @update:model-value="password = $event"></BFormInput>
						</BFormGroup>
						<BFormGroup :invalid-feedback="getValidationErrors('password_confirmation')" label="Confirm New Password">
							<BFormInput :model-value="password_confirmation" :state="getValidationState('password_confirmation')"
								type="password" @update:model-value="password_confirmation = $event"></BFormInput>
						</BFormGroup>
						<div class="d-flex justify-content-end flex-grow-1">
							<button
								class="btn btn-sm btn-primary float-right"
								@click="submitPasswordChange">
								Update Password
							</button>
						</div>
					</div>
				</div>
			</BTab>
			<BTab title="Payment Methods" lazy>
				<payment-methods />
			</BTab>
			<BTab v-if="isCleaner && user.vaccination_status !== 'Booster Shot'" title="Vaccination Status">
				<vaccination-status :force-show="true" variant="white"></vaccination-status>
			</BTab>
		</BTabs>
	</div>
</template>

<script>
	import { useValidation } from '@js/composables/useValidation.js';
	import PaymentMethods from './PaymentMethods.vue';
	import VaccinationStatus from './VaccinationStatus.vue';

	export default {
		name: 'MyAccount',
		components: {
			VaccinationStatus,
			PaymentMethods
		},
		setup() {
			return {
				...useValidation(),
			};
		},
		data() {
			return {
				user: {},
				avatar: null,
				password: null,
				password_confirmation: null,
				loading: false,
			}
		},
		mounted() {
			this.user = this.$store.getters['auth/user'];
		},
		methods: {
			submitPasswordChange() {
				this.loading = true
				this.clearErrors()

				this.$axios.put('/api/account/password', {
					password: this.password,
					password_confirmation: this.password_confirmation,
				})
					.then(() => {
						toastr.success('Password successfully changed.');
						this.password = null
						this.password_confirmation = null
					})
					.catch((err) => this.handleError(err))
					.finally(() => (this.loading = false))

			},
			setAvatarFile(event) {
				this.avatar = event.target.files[0] || null;
			},
			uploadAvatar() {
				if (!this.avatar) {
					return;
				}

				const formData = new FormData();
				formData.append('image', this.avatar);

				this.loading = true;
				this.clearErrors();

				this.$axios.post('/api/account/avatar', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				})
					.then((response) => {
						toastr.success('Avatar successfully updated.');
						this.avatar = null; // Clear the selected file
						this.user.avatar = response.data;
					})
					.catch((err) => this.handleError(err))
					.finally(() => this.loading = false);
			},
			removeAvatar() {
				this.loading = true;
				this.clearErrors();

				this.$axios.delete('/api/account/avatar')
					.then(() => {
						toastr.success('Avatar successfully removed.');
						this.user.avatar = null;
					})
					.catch((err) => this.handleError(err))
					.finally(() => this.loading = false);
			}
		}
	}
</script>

<style lang="scss" scoped>
.account-wrapper {
	.invalid-feedback {
		display: block;
	}
}
</style>
